import { render } from "./BasicQuerySection.vue?vue&type=template&id=105b3e4e&scoped=true"
import script from "./BasicQuerySection.vue?vue&type=script&lang=js"
export * from "./BasicQuerySection.vue?vue&type=script&lang=js"

import "./BasicQuerySection.vue?vue&type=style&index=0&id=105b3e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105b3e4e"]])

export default __exports__